import React from "react";
import { BsyUtils } from "../../utils/Utils";
import "./index.css";
import { BsyWidget } from "../BsyWidget";
import BsyFlowLog from "../BsyFlowLog";

class BsyFormLogPane extends BsyWidget {
  constructor(props) {
    super({
      baseCls: "bsy-log-wrapper",
      ...props,
    });

    this.items = [];
    if (this.options.hasFlowLog) {
      this.items.push("hasFlowLog");
    }
    if (this.options.hasLog) {
      this.items.push("hasLog");
    }
    if (this.options.hasComment) {
      this.items.push("hasComment");
    }
    this.state = {
      select: this.items[0],
      status: props.status || "false",
    };
  }

  componentDidMount() {
    super.componentDidMount();
    // this.readData();
    this.renderPane(this.items[0]);
  }

  renderPane = (type) => {
    switch (type) {
      case "hasFlowLog": {
        // this.renderFlowLog();
        break;
      }
      case "hasLog": {
        this.renderLog();
        break;
      }
      case "hasComment": {
        this.renderComment();
        break;
      }
      default: {
      }
    }
  };

  renderLog = () => {
    const {
      dataId,
      appId,
      authGroupId,
      fields,
      flowType,
      flow,
      flowId,
      entryId,
      formId,
      forms,
      popupFormPath,
      extDashData,
      refAppId,
    } = this.options;
    let el = this.element.current.querySelector(".hasLog");
    if (el) {
      this.DataDynamicPane =
        this.DataDynamicPane ||
        new window.FX.DataDynamicPane({
          renderEl: window.$("<div />").appendTo(window.$(el)),
          dataId: dataId,
          appId: appId || window.FX.STATIC.APPID,
          authGroupId: authGroupId,
          fields: fields,
          flowType: flowType ? flowType : flow ? flow.flowType : undefined,
          flowId: flowId ? flowId : flow ? flow.flowId : undefined,
          entryId: entryId,
          formId: formId || (BsyUtils.isArray(forms) ? forms[0] : forms),
          refAppId: refAppId,
          popupFormPath: popupFormPath,
          extDashData: extDashData,
        });
    }
  };
  renderFlowLog = () => {
    const {
      appId,
      authGroupId,
      flowType,
      flowId,
      entryId,
      formId,
      forms,
      extDashData,
      data,
      popupFormPath,
      refAppId,
    } = this.options;

    return (
      <BsyFlowLog
        data={data}
        authGroupId={authGroupId}
        appId={appId}
        flowType={flowType}
        flowId={flowId}
        refAppId={refAppId}
        entryId={entryId}
        extDashData={extDashData}
        popupFormPath={popupFormPath}
        formId={formId || (BsyUtils.isArray(forms) ? forms[0] : forms)}
      ></BsyFlowLog>
    );
  };
  renderComment = () => {
    const {
      dataId,
      appId,
      authGroupId,
      fields,
      flowType,
      flowId,
      flow,
      entryId,
      formId,
      forms,
      extDashData,
      data,
      logs,
      ignoreOptAuth,
      popupFormPath,
      refAppId,
    } = this.options;

    let el = this.element.current.querySelector(".hasComment");
    if (el) {
      this.DataCommentPane =
        this.DataCommentPane ||
        new window.FX.DataCommentPane({
          renderEl: window.$("<div />").appendTo(window.$(el)),
          dataId: dataId,
          data: data,
          appId: appId || window.FX.STATIC.APPID,
          popupFormPath: popupFormPath,
          ignoreOptAuth: ignoreOptAuth,
          refAppId: refAppId,
          logs: logs,
          authGroupId: authGroupId,
          fields: fields,
          flowType: flowType ? flowType : flow ? flow.flowType : undefined,
          flowId: flowId ? flowId : flow ? flow.flowId : undefined,
          entryId: entryId,
          formId: formId || (BsyUtils.isArray(forms) ? forms[0] : forms),
          extDashData: extDashData,
        });
    }
  };

  render() {
    const { hasComment, hasLog, hasFlowLog, cssName } = this.options;
    return (
      <div className={cssName} ref={this.element}>
        <div className="log-menu">
          {hasFlowLog ? (
            <div
              className={
                "menu-item " +
                (this.state.select === "hasFlowLog" ? "select" : "")
              }
              onClick={() => {
                this.setState(
                  {
                    pos: this.items.indexOf("hasFlowLog"),
                    select: "hasFlowLog",
                  },
                  () => {
                    this.renderPane("hasFlowLog");
                  }
                );
              }}
            >
              {React.language("flow.log")}
            </div>
          ) : (
            ""
          )}
          {hasLog ? (
            <div
              className={
                "menu-item " + (this.state.select === "hasLog" ? "select" : "")
              }
              onClick={() => {
                this.setState(
                  {
                    pos: this.items.indexOf("hasLog"),
                    select: "hasLog",
                  },
                  () => {
                    this.renderPane("hasLog");
                  }
                );
              }}
            >
              {React.language("dynamic")}
            </div>
          ) : (
            ""
          )}
          {hasComment ? (
            <div
              className={
                "menu-item " +
                (this.state.select === "hasComment" ? "select" : "")
              }
              onClick={() => {
                this.setState(
                  {
                    pos: this.items.indexOf("hasComment"),
                    select: "hasComment",
                  },
                  () => {
                    this.renderPane("hasComment");
                  }
                );
              }}
            >
              {React.language("comment")}
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="log-main">
          {hasFlowLog ? (
            <div
              className="main-item hasFlowLog"
              style={{
                display: this.state.select === "hasFlowLog" ? "block" : "none",
              }}
            >
              {this.renderFlowLog()}
            </div>
          ) : (
            ""
          )}
          {hasLog ? (
            <div
              className="main-item hasLog"
              style={{
                display: this.state.select === "hasLog" ? "block" : "none",
              }}
            ></div>
          ) : (
            ""
          )}
          {hasComment ? (
            <div
              className="main-item hasComment"
              style={{
                display: this.state.select === "hasComment" ? "block" : "none",
              }}
            ></div>
          ) : (
            ""
          )}
        </div>
        <div
          className="log-wrapper-switch"
          style={{ left: this.state.status == "false" ? "" : "-36px" }}
          onClick={() => {
            this.setState(
              {
                status: this.state.status == "false" ? "true" : "false",
              },
              () => {
                this.props.onExpand && this.props.onExpand(this.state.status);
              }
            );
          }}
          onMouseEnter={(e) => {
            window.FX.UI.showPopover({
              position: "leftBottom",
              anchor: window.$(e.currentTarget),
              edge: 12,
              content: window
                .$("<span/>")
                .text(
                  this.state.status == "false"
                    ? React.language("collect")
                    : React.language("display.show")
                ),
              type: "dark",
              // animation: !1
            });
          }}
          onMouseLeave={() => {
            window.FX.UI.closePopover();
          }}
        >
          {this.state.status == "false" ? (
            <i className="icon-double-right"></i>
          ) : (
            <i className="icon-double-left"></i>
          )}{" "}
        </div>
      </div>
    );
  }
}

export default BsyFormLogPane;
